import React from 'react';

// i18n
import { withTranslation } from 'react-i18next';

// Routes
import { withRouter } from 'react-router-dom';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import {
  toggleAppSidebar
} from '../../modules/app';
import styled from 'styled-components';

const SidebarToggleButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 0 12px;
  &:focus-visible {
    outline: 2px solid var(--br-focus);
    outline-offset: -3px;
  }
  @media only screen and (max-width: 767px) {
    display: ${({$hideOnMobile}) => $hideOnMobile ? 'none' : 'flex'};
  }
`;

export const isBookWorkspacePath = pathname =>
  /^\/books\/[^/]+/.test(pathname || '');

export const SidebarToggler = ({
  sidebarVisible,
  userProfile,
  location,

  toggleAppSidebar
}) => {
  const isBookWorkspace = !!userProfile && isBookWorkspacePath(location?.pathname);

  return (
    <SidebarToggleButton
      type="button"
      className="item"
      $hideOnMobile={!!userProfile && !isBookWorkspace}
      key='menu-opener'
      aria-label={isBookWorkspace
        ? sidebarVisible ? 'Close book menu' : 'Open book menu'
        : sidebarVisible ? 'Close menu' : 'Open menu'}
      aria-expanded={!!sidebarVisible}
      onClick={() => toggleAppSidebar(!sidebarVisible)}
    >
      <span aria-hidden="true">{sidebarVisible ? '×' : '☰'}</span>
    </SidebarToggleButton>
  );
}

// redux stuff
const mapStateToProps = state => ({
  sidebarVisible: state.app.sidebarVisible,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleAppSidebar,
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarToggler)));
